import { AlertTriangle } from "lucide-react";
import type { ModelAssignment } from "@/services/adminModelCurrency";
import { formatDateTime } from "../programNews/formatters";
import ResetBaselineAction from "./ResetBaselineAction";

interface AssignmentDetailsProps {
  assignment: ModelAssignment;
  useCaseId: string;
  writable: boolean;
  onResetBaseline: (useCaseId: string) => Promise<unknown>;
}

const AssignmentDetails = ({
  assignment,
  useCaseId,
  writable,
  onResetBaseline,
}: AssignmentDetailsProps) => (
  <div className="space-y-2 text-xs text-muted-foreground">
    <p>
      Previously {assignment.previousModel ?? "the built-in setting"}. Changed by{" "}
      {assignment.assignedBy ?? "an admin"} on {formatDateTime(assignment.assignedAt)}.
    </p>
    {assignment.needsRebaseline ? (
      <div className="space-y-2 rounded-md border border-amber-300 bg-amber-50 p-2 text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200">
        <p className="flex items-start gap-1.5">
          <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          This use case needs a new baseline: the automatic tests are still comparing against the
          old model.
        </p>
        {writable ? (
          <ResetBaselineAction useCaseId={useCaseId} onResetBaseline={onResetBaseline} />
        ) : null}
      </div>
    ) : null}
  </div>
);

export default AssignmentDetails;
